import { Stack, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks';
import { useNavigate } from 'react-router-dom';
import { Paths } from 'services/navigation/paths';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { useShallow } from 'zustand/react/shallow';

export const SourcingInternalSuccessStep = () => {
  const navigate = useNavigate();
  const { navigateToPath } = usePathsV2();
  const { selectedCandidateProfiles, candidateBatch } =
    useSourcingInternalStore(
      useShallow((state) => ({
        selectedCandidateProfiles: state.selectedCandidateProfiles,
        candidateBatch: state.candidateBatch
      }))
    );
  const { track } = useTracking();

  const candidateCount = selectedCandidateProfiles?.length ?? 0;

  return (
    <Stack gap="30px" maxWidth="500px" mx="auto">
      <Typography variant="title">Done!</Typography>
      <Typography variant="subTitle">
        The {candidateCount} candidate
        {candidateCount !== 1 ? 's have ' : ' has '}
        been added to the "invited" tab within your analysis.
      </Typography>
      <Stack direction="row" gap="20px">
        <Button
          variant="primary"
          onClick={() => {
            if (!candidateBatch) return;
            navigate(
              `${Paths.ANALYSE}/${candidateBatch.id}?tab=Source_candidates`
            );
          }}
        >
          View invited candidates
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            if (!candidateBatch) return;
            track(TrackingEventName.SourcingSuccessFindMoreCandidates, {
              candidateBatchId: candidateBatch.id
            });
            navigateToPath.ANALYSE_CANDIDATE_PROFILE_LIST({
              candidateBatchId: candidateBatch.id
            });
          }}
        >
          Source more candidates
        </Button>
      </Stack>
    </Stack>
  );
};
